import { OrderGroupDetailed } from 'src/reactQuery/orders/interfaces/orderGroup.interface';
import { API_URL_M7, getCachedSessionId } from 'src/services/common';
import { apiM7 } from 'src/util/axios-instance';

export const getOrdersGroup = async (params: {
  page: string;
  pageSize: string;
  projectId: string;
  search: string;
  sortBy: string;
  sortOrder: string;
}): Promise<OrderGroupDetailed[] | undefined> => {
  const { projectId, page, pageSize, sortBy, sortOrder, search } = params;
  const response = await apiM7.get<OrderGroupDetailed[]>(
    `${API_URL_M7}/api_admin/v1/project/${projectId}/ecommerce/order-group/search?limit=${pageSize}&page=${page}&search=${search}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
    {
      headers: { 'x-session-id': getCachedSessionId() }
    }
  );

  return response.data;
};
